import { memo, useCallback } from 'react';

import InputField from '../../../common/fields/InputField';
import SectionCard from './SectionCard';

export default memo(function AccountSection({ formData, errors, isEdit, onChange }) {
  const handleFirstNameChange = useCallback(
    (e) => onChange({ firstName: e.target.value }),
    [onChange],
  );
  const handleLastNameChange = useCallback(
    (e) => onChange({ lastName: e.target.value }),
    [onChange],
  );
  const handlePhoneChange = useCallback((e) => onChange({ phone: e.target.value }), [onChange]);
  const handlePasswordChange = useCallback(
    (e) => onChange({ password: e.target.value }),
    [onChange],
  );

  return (
    <SectionCard title="Account Information">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <InputField
          label="First Name *"
          value={formData.firstName}
          onChange={handleFirstNameChange}
          error={!!errors.firstName}
          helperText={errors.firstName}
        />
        <InputField
          label="Last Name *"
          value={formData.lastName}
          onChange={handleLastNameChange}
          error={!!errors.lastName}
          helperText={errors.lastName}
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <InputField
          label="Phone Number *"
          type="tel"
          value={formData.phone}
          onChange={handlePhoneChange}
          error={!!errors.phone}
          helperText={errors.phone}
          inputProps={{
            inputMode: 'numeric',
            maxLength: 10,
            pattern: '0[0-9]{9}',
          }}
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
        <InputField
          label={isEdit ? 'Password (leave blank to keep)' : 'Password *'}
          type="password"
          value={formData.password}
          onChange={handlePasswordChange}
          error={!!errors.password}
          helperText={errors.password}
        />
      </div>
    </SectionCard>
  );
});
